export default function (state, newFilterOption) {
  return {
    ...state,
    sortOptions: newFilterOption,
  }
}
